import script from "./TurnstileWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./TurnstileWidget.vue?vue&type=script&setup=true&lang=js"

import "./TurnstileWidget.vue?vue&type=style&index=0&id=3a36e239&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a36e239"]])

export default __exports__